import React, { Component } from 'react'
import "bootstrap/dist/css/bootstrap.css";
import { TableRow, TableCell, Link } from '@aws-amplify/ui-react';
import { downloadfile } from '../../utils/utils';
import { Trash } from 'react-bootstrap-icons';

class QuerySerachReportsRow extends Component {

    render() {
        let Querys = "";
        //  Querys = this.props.entity.Query.forEach(element => {
        //     Querys+=element;
        // });
        // console.log(this.props.entity);
        return (
            <TableRow>
                <TableCell>
                {this.props.index+1}
                </TableCell>
                <TableCell>
                <Link className='App-link text-center' onClick={() => downloadfile(this.props.projectid, this.props.entity.document)}>
                        {this.props.entity.document}
                    </Link>
                </TableCell>
                <TableCell>
                {this.props.entity.page}
                </TableCell>
                <TableCell style={{ textAlign: 'justify'}} dangerouslySetInnerHTML={{ __html: this.props.entity.highlight }}>
                </TableCell>
                <TableCell>
                    {null}
                </TableCell>
                <TableCell>
                    <Link className='App-link text-center' onClick={() => this.props.onDelete(this.props.entity)}>
                        <Trash/>
                    </Link>
                </TableCell>
            </TableRow>
        )
    }
}
export default QuerySerachReportsRow;